/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { GetConversationQueryResponse, GetConversationPathParams, GetConversation401, GetConversation500 } from "../../types/chatController/GetConversation.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { getConversation } from "../../client/chatController/getConversation.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getConversationQueryKey = (organizationId: GetConversationPathParams["organizationId"] | undefined, conversationId: GetConversationPathParams["conversationId"] | undefined) => [{ url: '/api/organizations/:organizationId/chat/conversations/:conversationId', params: {organizationId:organizationId,conversationId:conversationId} }] as const

export type GetConversationQueryKey = ReturnType<typeof getConversationQueryKey>

export function getConversationQueryOptions(organizationId: GetConversationPathParams["organizationId"] | undefined, conversationId: GetConversationPathParams["conversationId"] | undefined, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = getConversationQueryKey(organizationId, conversationId)
        return queryOptions<GetConversationQueryResponse, ResponseErrorConfig<GetConversation401 | GetConversation500>, GetConversationQueryResponse, typeof queryKey>({
         enabled: !!(organizationId && conversationId),
         queryKey,
         queryFn: async ({ signal }) => {
            return getConversation(organizationId!, conversationId!, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get a single conversation with messages
 * {@link /api/organizations/:organizationId/chat/conversations/:conversationId}
 */
export function useGetConversation<TData = GetConversationQueryResponse, TQueryData = GetConversationQueryResponse, TQueryKey extends QueryKey = GetConversationQueryKey>(organizationId: GetConversationPathParams["organizationId"] | undefined, conversationId: GetConversationPathParams["conversationId"] | undefined, options: 
{
  query?: Partial<QueryObserverOptions<GetConversationQueryResponse, ResponseErrorConfig<GetConversation401 | GetConversation500>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? getConversationQueryKey(organizationId, conversationId)
         

         const query = useQuery({
          ...getConversationQueryOptions(organizationId, conversationId, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<GetConversation401 | GetConversation500>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}